import {Component, Input, OnInit} from '@angular/core';
import {ListingService} from '../../../services/listing.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {createCheckoutUrl} from '../../checkout/checkout-route';

@Component({
    selector: 'product-products',
    templateUrl: './product-products.component.html',
    styleUrls: ['./product-products.component.scss'],
    standalone: false
})
export class ProductProductsComponent implements OnInit {
  @Input() product: any;
  @Input() scheme;

  public items = [];

  constructor(
    protected listingService: ListingService,
    private readonly snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.loadItems();
  }

  async loadItems() {
    this.items = await this.listingService.loadListingProducts(
      this.product.id
    );
  }

  pickOptions(item): void {
    const checkoutUrl = createCheckoutUrl(
      this.product?.id,
      item?.id,
      new URLSearchParams(window.location.search).get('temp')
    );

    if (checkoutUrl) {
      window.location.assign(checkoutUrl);
      return;
    }

    this.snackBar.open(
      'Unable to start checkout. Please try again.',
      'Close',
      {duration: 5000}
    );
  }
}
